import { useEffect } from "react";

const useInjectHeadHTML = (html, marker) => {
    useEffect(() => {
        if (!html || typeof window === "undefined") return;

        const template = document.createElement("template");
        template.innerHTML = html;

        const injected = [];

        const cloneAttributes = (from, to) => {
            for (const attr of Array.from(from.attributes)) {
                try { to.setAttribute(attr.name, attr.value); } catch { /* ignore invalid attrs */ }
            }
        };

        const appendNode = (node) => {
            if (node.nodeType === Node.ELEMENT_NODE && (node).tagName === "SCRIPT") {
                const original = node;
                const script = document.createElement("script");
                cloneAttributes(original, script);
                script.setAttribute("data-injected-by", marker);
                if (original.src) {
                    script.async = original.async;
                    script.defer = original.defer;
                } else {
                    script.text = original.textContent || "";
                }
                document.head.appendChild(script);
                injected.push(script);
                return;
            }

            if (node.nodeType === Node.ELEMENT_NODE) {
                const el = node;
                const clone = el.cloneNode(true);
                clone.setAttribute("data-injected-by", marker);
                document.head.appendChild(clone);
                injected.push(clone);
                return;
            }

            if (node.nodeType === Node.COMMENT_NODE) {
                const clone = node.cloneNode(true);
                document.head.appendChild(clone);
                injected.push(clone);
            }
        };

        Array.from(template.content.childNodes).forEach(appendNode);

        return () => {
            injected.forEach(node => {
                if (node.parentNode) node.parentNode.removeChild(node);
            });
        };
    }, [html, marker]);
};
export default useInjectHeadHTML;